export const GetCdrDetailList = (builder) => ({
    GetCdrDetailList: builder.mutation({
        query: ({ startDate, endDate, page, limit, user_name }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/get_data_of_cdr_list',
                method: 'GET',
                params: { startDate, endDate, page, limit, user_name },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});